export default {
	InvoiceList: {
		HeaderList: {
			Attached: 'Attachments',
			SellerAddress: 'Seller Address',
			TaxReduction: 'Total tax reduction amount on tax-reduced sales invoice',
			ChangeStatusInvoiceDate: 'Status change date on Tax Authority',
			WarningPaymentDueDate: 'Payment due date reminder',
			CompanyTax: 'Company Tax Code',
			BranchTax: 'Branch Tax Code',
			SellerTaxCode: 'Seller Tax Code',
			BuyerTaxCode: 'Buyer Tax Code'
		}
	},
	DeclarationList: {
		HeaderList: {
			TotalPreCustomsFee: 'Total pre-customs fee',
			TotalPreCustomsFeeExchange: 'Total pre-customs fee exchange',
			CompanyTax: 'Company tax code',
			BranchTax: 'Branch tax code',
			InvoiceNo: 'Invoice No.'
		}
	}
};
